/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type CartNav_user = {
    readonly profile: {
        readonly currency: Currency | null;
    } | null;
    readonly " $refType": "CartNav_user";
};
export type CartNav_user$data = CartNav_user;
export type CartNav_user$key = {
    readonly " $data"?: CartNav_user$data;
    readonly " $fragmentRefs": FragmentRefs<"CartNav_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CartNav_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'a56ba97f4561a08ba9b65787eb607cf6';
export default node;
